import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import { modKeySymbol } from '@/hooks/useHotkey';

/**
 * Bouton stylé comme un input qui ouvre la CommandPalette. La recherche
 * réelle et la navigation clavier vivent dans `CommandPalette`.
 */
export function SearchBar({ onOpen, className }: { onOpen: () => void; className?: string }) {
  const mod = modKeySymbol();
  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        'group flex h-9 w-full max-w-xl items-center gap-2 rounded-md border border-border-subtle bg-gray-50 px-3 text-left text-sm text-text-muted shadow-[inset_0_1px_2px_rgba(27,42,71,0.04)] transition-colors hover:border-accent hover:text-brand',
        className,
      )}
    >
      <Search className="h-4 w-4 shrink-0 text-text-muted" />
      <span className="flex-1 truncate">Rechercher un prospect, SIRET, action…</span>
      <span className="flex items-center gap-1">
        <kbd className="inline-flex h-5 min-w-[20px] items-center justify-center rounded border border-border-subtle bg-white px-1 font-mono text-[10px] font-medium text-text-muted shadow-sm">
          {mod}
        </kbd>
        <kbd className="inline-flex h-5 min-w-[20px] items-center justify-center rounded border border-border-subtle bg-white px-1 font-mono text-[10px] font-medium text-text-muted shadow-sm">
          K
        </kbd>
      </span>
    </button>
  );
}
